import { MAX_VISIT_PRICE } from '../../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { text } from '../constants'
import type { NewServiceVisitType } from '../types'

type CostErrorsMessages = {
  costError: string
  cancelationFeeError: string
}

export const checkCostErrors = (
  serviceType: Pick<NewServiceVisitType, 'Cost' | 'CancellationFee'>,
): CostErrorsMessages => {
  const { Cost, CancellationFee } = serviceType

  const costErrorsMessages: CostErrorsMessages = {
    costError: '',
    cancelationFeeError: '',
  }

  if (Cost === '') {
    costErrorsMessages.costError = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.COST_USD)
  }
  if (CancellationFee === '') {
    costErrorsMessages.cancelationFeeError = getUserFriendlyErrorMessage(
      errorCodes.FIELD_REQUIRED,
      null,
      text.CANCELATION_FEE_USD,
    )
  }
  if (Number(Cost) > MAX_VISIT_PRICE) {
    costErrorsMessages.costError = getUserFriendlyErrorMessage(errorCodes.BIG_VALUE, null, String(MAX_VISIT_PRICE))
  }
  if (Number(CancellationFee) > MAX_VISIT_PRICE) {
    costErrorsMessages.cancelationFeeError = getUserFriendlyErrorMessage(
      errorCodes.BIG_VALUE,
      null,
      String(MAX_VISIT_PRICE),
    )
  }
  if (Number(CancellationFee) > Number(Cost)) {
    costErrorsMessages.cancelationFeeError = getUserFriendlyErrorMessage(
      errorCodes.BIG_VALUE,
      null,
      String(Cost || text.COST_USD_FIELD_VALUE),
    )
  }

  return costErrorsMessages
}
